import {Component, Input, OnInit, ViewContainerRef} from "@angular/core";
import {FormComponent} from "./model/form-component";
import {FormGroup} from "@angular/forms";
import {DynamicComponentBuilder} from "./dynamic-component-builder.service";

@Component({
    selector: "dynamic-renderer",
    template: `<div id="id_{{component.id}}" class="dynamic-renderer"></div>`
})
export class RendererComponent implements OnInit {

    @Input()
    component: FormComponent;

    @Input()
    data: any;

    @Input()
    formGroup: FormGroup;

    constructor(private dynamicFormsBuilderService: DynamicComponentBuilder, private viewContainerRef: ViewContainerRef) {
    }

    ngOnInit(): void {
        this.dynamicFormsBuilderService.build(this.component, this.data, this.formGroup, this.viewContainerRef);
    }

}
